export default "__VITE_ASSET__959284d8__"